import { Image, Platform, ScrollView, ImageBackground, ActivityIndicator, StyleSheet } from 'react-native';
import { Theme, themeColorSet, ThemedPressable, ThemedText, ThemedView } from '../../theme';
import Button from '@app/sharedComponents/Button/Button';
import { CaretRight,Info } from '@app/sharedComponents/Icons/Icons';
import { formatIndianCurrency, isEmptyObject } from '@app/utils/utility';
import axios from 'axios';
import { endpoints } from '@app/api/apis';
import { useAppSelector } from '@app/store/hooks';
import { checkColor } from '@app/utils/utils';
import ROUTE from '@app/navigationApp/routes';
import AsyncStorage from "@react-native-async-storage/async-storage";
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import CarouselInfoCards from '../LMSDasboard/components/CarouselInfoCards';
import dayjs from 'dayjs';
import { useFocusEffect, useIsFocused } from '@react-navigation/native';
import { useState,useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import handleApiErr from '@app/helper/handleApiErr';
import LoanExpiredCard from '../LMSDasboard/components/LoanExpiredCard';
import BackButton from '@app/sharedComponents/BackButton/BackButton';
import { updateLinkedApplication } from '@app/store/slices/authSlice';
import fetchUserDetails from '@app/helper/fetchUserInfo';
import TooltipComp from '@app/sharedComponents/Tooltip/Tooltip';
import { useTheme } from '@shopify/restyle';
import ManageLimitNet from '@app/assets/svg/ManageLimitNet';


export const MANAGE_LIMIT =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Empty_Limit.png';

const ZeroState = ()=>{
  return(
    <ThemedView flex={1} backgroundColor='bg-surface-primary' >
    <ThemedView
        justifyContent='center'
        alignItems='center'
        m="5xl"
        >
        <Image
          source={{ uri: MANAGE_LIMIT }}
          style={{
            height: Platform.OS !== 'web' ? 250 : 200,
            width: Platform.OS !== 'web' ? '100%' : 200,
          }}
          resizeMode={'contain'}
        />
        <ThemedText variant='b2s' color='text-secondary' textAlign='center' >
        You can manage your credit limit, and mark or unmark your funds from
        here after you start your credit limit
        </ThemedText>
      </ThemedView>
      </ThemedView>
  )
}

function ManageLimit({navigation}) {

  const dispatch = useDispatch()
  const {isfromTDL} = useAppSelector(state => state.platformParams);

  const userDetails = useAppSelector((state) => state.auth.userDetails);
  const pendingRequestDetails = useAppSelector((state) => state.auth.pendingRequestDetails);
  const [showToolTip, setShowToolTip] = useState(false);
  const [isLoading,setIsLoading] = useState(true)
  const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
  const [isAccountInForeClosure, setIsAccountInForeClosure] = useState({});
  const creditInfo = useAppSelector((state) => state.auth.creditDetails);
  const {callData ,platform} = useAppSelector((state) => state?.platformParams); 
  const isLMSUser = useAppSelector((state) => state.commonReducer.isLMSUser);
  const [isForeClosureStatusLoading, setIsForeClosureStatusLoading] = useState(false);
  const [isIncreaseLimitLoading, setIsIncreaseLimitLoading] = useState(false);
  const firebaseParams = useAppSelector((state) => state.firebaseParams);
  const {colors} = useTheme<Theme>();

  const {enable_ToFu_Flag,enable_ToFu_Flag_test_numbers} = firebaseParams;
  const isFocused = useIsFocused()

  const activeEnhancementApplication = userDetails?.activeEnhancementApplication;
  const isEnhancementApplicationInProgress = activeEnhancementApplication && Object.keys(activeEnhancementApplication)?.length > 0;
  const enableToFuFlag = (enable_ToFu_Flag === 'true' ||enable_ToFu_Flag_test_numbers?.includes(userDetails?.user?.phoneNumber)) ? true : false;
  const showEnhancementMessage =enableToFuFlag && isEnhancementApplicationInProgress && activeEnhancementApplication?.messageForUserToDisplay !== '' && activeEnhancementApplication?.messageForUserToDisplay !== null;

  const getContactNumberForCall = (defaultNum:string) =>{
    if (platform === 'FREO') {
      return '+916364465607'
    } else if (platform === 'JUPITER') {
        return '+918655055086'
    } else {
        return defaultNum
    }
  }
  
  const closeBottomSheet = () => {
    setIsBottomSheetVisible(false);
    setShowToolTip(false)
  };


const fetchNewApplication = ()=>{
  const payload =    {
    creditApplicationType: "CREDIT_MODIFICATION_AGAINST_SECURITIES",
}
  const creditId = userDetails?.linkedCredits[0]?.creditId
  const url = endpoints.enhanceLimit + creditId + '/v2'
  const manageLimitConfigUrl = endpoints.manageLimitConfig + creditId;
  setIsIncreaseLimitLoading(true);
  axios.get(manageLimitConfigUrl).then((res)=>{
    const manageLimitConfig = res?.data;
    const showIncreaseLimit = manageLimitConfig.increaseLimitAllowed;
    // const showDecreaseLimit = manageLimitConfig.decreaseLimitAllowed;
    if(showIncreaseLimit){
      axios.post(url,payload).then((res)=>{
        const applicationId = res?.data?.applicationId;
        dispatch(updateLinkedApplication(res?.data))
        AsyncStorage.setItem("application_id", applicationId);
        AsyncStorage.setItem("is_from_enhance_limit", "true");
        AsyncStorage.setItem("currentStepId", res?.data?.currentStepId);
        AsyncStorage.setItem('newUserData', JSON.stringify(res?.data))
        fetchUserDetails();
        navigation.navigate("MANAGE_LIMIT_LANDING");
      }).catch((err)=>{
        console.log('newApplication',err);
        if(handleApiErr(err)){
          dispatch(
            showErrorSheet({
              isErrorSheetVisible: true,
              errorMessage: err?.data?.message || 'Something went wrong',
              closeOnBackdropPress: true,
              errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
              errorHeading: err?.data?.header,
              btnName: 'Ok, got it!'
            }),
          );
        }
      }).finally(()=>{
        setIsIncreaseLimitLoading(false);
      });
    } else {
      setIsIncreaseLimitLoading(false);
      dispatch(showErrorSheet({
            isErrorSheetVisible: true,
            errorMessage: "You'll be able to increase limit as soon as the account set up is complete. Please try again after sometime",
            closeOnBackdropPress: true,
            errorType: 'ACCOUNT_SETUP_IN_PROGRESS',
            errorHeading: 'Account set up-in progress',
            showErrorHeading: true,
            btnName:'Ok, got it!',
        }))
    }
  }).catch((err) => {
    console.log('manageLimitConfig error', err);
    setIsIncreaseLimitLoading(false);
  });
}
const fetchForClosureStatus = () =>{
  if(userDetails?.linkedCredits[0]?.creditStatus !== 'PENDING_CLOSURE'){
    setIsForeClosureStatusLoading(false);
    setIsLoading(false);
    setIsAccountInForeClosure({})
    return
  }
  const url = endpoints.checkForClosureStatus + userDetails?.linkedCredits[0]?.creditId
  setIsForeClosureStatusLoading(true);
  axios.get(url)
  .then((res)=>{
    setIsAccountInForeClosure(res?.data)
  }
  ).catch((err)=>{
    console.log('fetchClosureRequest',err)
  }
  ).finally(()=>{ 
    setIsForeClosureStatusLoading(false);
    setIsLoading(false);
  }
  )
}



  useEffect(() => {
    fetchForClosureStatus()
  }, [isFocused])


  if((isLoading || Object.keys(creditInfo)?.length === 0) && isLMSUser){
    return(
      <ThemedView bg='bg-surface-primary' flex={1} justifyContent='center' alignItems='center'>
          <ActivityIndicator size={12} color={checkColor("#1434CB")} />
      </ThemedView>
    )
  }
  const renewalDate = dayjs(userDetails?.linkedCredits[0]?.renewalDate)
  const currentDate = dayjs()
  const isLoanExpired = renewalDate.isBefore(currentDate) ;
    return (
      <>
      <ThemedView bg='bg-surface-primary' flex={1}>
        <ThemedView flexDirection='row' alignItems='center' height={60} px="lg" py="md"  borderBottomWidth={1} borderBottomColor='border-secondary' backgroundColor='bg-surface-primary'>
          {isfromTDL && <ThemedView mr="sm">
          <BackButton navigation={navigation} />
          </ThemedView>}
          <ThemedText variant='h5s' color='text-primary' >Manage Limit</ThemedText>
        </ThemedView>
        {!isLMSUser && <ZeroState/>}
        {isLMSUser &&
        <>
       {isAccountInForeClosure?.status === 'IN_REVIEW' ? 
       <ThemedView
          m='5xl'
          justifyContent='center'
          alignItems='center'
          >
          <Image
            source={{ uri: MANAGE_LIMIT }}
            style={{
              height: Platform.OS !== 'web' ? 250 : 200,
              width: Platform.OS !== 'web' ? '100%' : 200,
            }}
            resizeMode={'contain'}
          />
          <ThemedText variant='b2s' color='text-secondary' textAlign='center' mt='5xl'>
          You can manage your credit limit, and mark or unmark your funds from
          here after you start your credit limit
          </ThemedText>
        </ThemedView>:
        <ScrollView contentContainerStyle={{flex: 1,  backgroundColor:'bg-surface-primary'}}>
        {!isForeClosureStatusLoading && isLoanExpired && isEmptyObject(isAccountInForeClosure) && pendingRequestDetails?.renewalRequestDetailsList?.length<1 &&
          <LoanExpiredCard creditInfo={creditInfo}  navigation={navigation} contactNumber={getContactNumberForCall(callData)} showFaqs={false}/> }
        <ThemedView mx="lg" borderRadius='lg'>
          <ThemedView my="md" >
            <ThemedView backgroundColor='bg-fill-emphasis-primary-1' borderRadius='md'>
              <ManageLimitNet width="100%" height="100%" style={StyleSheet.absoluteFillObject} color={colors['icon-action-primary']}/>
              <ThemedView pt="2xl" px="lg" flexDirection='row' style={{marginBottom:showEnhancementMessage ? 0 : 24}}>
                    <Image
                      source={{
                          uri: isfromTDL ?
                              'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Personal+Loan_FS.png' :
                              'https://s3.ap-south-1.amazonaws.com/staging.voltmoney.in/images/rupee_new_1.png',
                      }}
                      style={{width: 60, height: 60}}
                      />
                    <ThemedView ml="sm" justifyContent='center'>
                      <ThemedText variant='b3m' color='text-secondary' mb='xs'>
                      Credit limit
                      </ThemedText>
                      <ThemedView flexDirection='row' alignItems='center'>
                        <ThemedText variant='l1' color='text-primary'>₹</ThemedText>
                        <ThemedText variant='h1b' color='text-primary'  style={{marginTop:Platform.OS === 'ios' ? 4: 0}}>
                        {formatIndianCurrency(Math.floor(creditInfo?.actualLoanAmount))}{' '}
                        </ThemedText>
                        <ThemedPressable onPress={()=>{setIsBottomSheetVisible(true)}}>
                          <Info size={18} color={colors['icon-primary']}/>
                        </ThemedPressable>
                      </ThemedView>
                    </ThemedView>
                  </ThemedView>
                  {showEnhancementMessage && <ThemedView mt='md' mb='lg' mx='md' py='xs' px='md' backgroundColor='bg-surface-primary' borderRadius='sm'>
                    <ThemedText variant='b4s' color='text-emphasis-secondary'>  
                      {activeEnhancementApplication?.messageForUserToDisplay}
                    </ThemedText>
                  </ThemedView>}
              </ThemedView>
            </ThemedView>
            {!isLoanExpired &&
            <Button 
              buttonLoader={isIncreaseLimitLoading} 
              eventName={showEnhancementMessage ? 'CONTINUTE_TO_ENHANCE_LIMIT_BUTTON' : 'ENHANCE_LIMIT_BUTTON' }
              type="SOLID" label={showEnhancementMessage ? "Continue to increase limit" : "Increase limit"} 
              handlePress={async ()=>{
              await AsyncStorage.removeItem('isElevate')
                fetchNewApplication()
              }} 
            additionalProperties={{
              source : 'manage_limit'
            }}
            />}
            <ThemedView backgroundColor='border-primary' my="2xl" height={1} width={'100%'}/>
            <ThemedText variant='h5b' color='text-primary' mb="lg" >Pledged portfolio</ThemedText>
            <ThemedView py="lg" backgroundColor='bg-fill-primary' borderWidth={1} borderRadius='md' borderColor='border-primary' >
                  <ThemedView px="lg">
                    <ThemedView flexDirection='row'>
                      <Image
                          source={{
                              uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/image+1997.png',
                          }}
                          style={{width: 26, height: 26}}
                      />
                      <ThemedText variant='b2s' color="text-primary">Mutual funds</ThemedText>
                    </ThemedView>
                    <ThemedView flexDirection='row' justifyContent='space-between' alignItems='center' mt="lg">
                      <ThemedText variant='b3r' color="text-primary">Portfolio value</ThemedText>
                      <ThemedText variant='b2r' color="text-primary">₹{formatIndianCurrency(creditInfo?.totalValueOfAssetsPledged)}</ThemedText>
                    </ThemedView>
                  </ThemedView>
  
                  <ThemedView my="lg" height={1} backgroundColor='border-secondary'/>
                  <ThemedView mx="lg" flexDirection='row' justifyContent='flex-end'>
                    <Button type="TEXT" handlePress={()=>navigation.navigate(ROUTE.PLEADGE_MF)} label="View details" showRightAccessory={true} rightAccessory={()=> <CaretRight size="16" color={themeColorSet['text-action-primary']} />}/>
                  </ThemedView>
          </ThemedView>
        </ThemedView>
        </ScrollView>
        }
        <BottomSheetContainer
          isVisible={isBottomSheetVisible}
          close={closeBottomSheet}
          closeOnBackdropPress={true}
          borderTopRightRadius={10}
          borderTopLeftRadius={10}
          showCloseIcon
          >
            <ThemedPressable p="lg" onPress={()=> setShowToolTip(false)}>
                <ThemedText variant='h5s' color='text-primary' mb="4xl">Credit limit</ThemedText>
                <ThemedView borderRadius='sm' borderWidth={1} borderColor='border-primary' p="md" mb ="lg">
                  <ThemedView flexDirection='row' justifyContent='space-between' mb ="md">
                    <ThemedText variant='b3s' color="text-secondary">Credit limit against portfolio</ThemedText>
                    <ThemedText variant='b3s' color="text-secondary">₹{formatIndianCurrency(userDetails?.linkedCredits[0]?.actualLoanAmount)}</ThemedText>
                  </ThemedView>
                  <ThemedView flexDirection='row' justifyContent='space-between'>
                    <ThemedView flexDirection='row' alignItems='center'>
                    <ThemedText variant='b3r' color="text-secondary">Max loan amount sanctioned </ThemedText>
                      <ThemedPressable onPress={()=>setShowToolTip(!showToolTip)}>
                        <Info size={16}/>
                        {showToolTip &&
                          <TooltipComp
                              title={"This is the max sanctioned loan amount approved as per your loan agreement, it can be revised by doing another agreement by increasing your limit"}
                          />
                        }
                      </ThemedPressable>
                    </ThemedView>
                    <ThemedText variant='b3s' color="text-secondary">₹{formatIndianCurrency(userDetails?.linkedCredits[0]?.approvedCreditAmount)}</ThemedText>
                  </ThemedView>
                  <ThemedView my="lg" backgroundColor='border-secondary' height={1} width={'100%'} />
                  <ThemedView flexDirection='row' justifyContent='space-between'>
                      <ThemedText variant='b3s' color="text-primary">Credit limit </ThemedText>
                    <ThemedText variant='b3s' color="text-emphasis-secondary">₹{formatIndianCurrency(userDetails?.linkedCredits[0]?.actualLoanAmount)}</ThemedText>
                  </ThemedView>
                </ThemedView>
                <Button type="SOLID" label="Ok, got it!" handlePress={()=>{setIsBottomSheetVisible(false) 
               setShowToolTip(false)  
              }
              
              } />
            </ThemedPressable>
            
        </BottomSheetContainer>
        </>
      }
      </ThemedView>
      </>
    );
}

export default ManageLimit;
